import type { DataOption } from '@/common.types'
import type { GetTicketTypesParams } from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export function useTicketTypesQuery(
	queryParams: GetTicketTypesParams,
	options?: UseQueryOptions<any, Error, DataOption[]>
) {
	return useQuery<DataOption[], Error, DataOption[]>({
		queryKey: ['ticket-types', queryParams],
		queryFn: () => client.tickets.getTicketTypes(queryParams),
		...(options || {}),
	})
}
